import React, { Component } from 'react';
import {
    IPersonaProps,
    Label,
    NormalPeoplePicker,
    PeoplePickerItemSuggestion
} from "office-ui-fabric-react";
import { Group } from "@microsoft/microsoft-graph-types";

import * as MicrosoftGraph from "@microsoft/microsoft-graph-client";

import { connect } from "react-redux";
import { IRootState } from "../store";
import ApiService from "./ApiService";
import { CreateSiteFormGroup } from "../models/CreateSiteForm";
import { getDateOnlyFromDateTimeString } from '../utils/Utils';

type GroupType = "Security" | "Office 365" | "Mail Enabled Security" | "Distribution List";

export interface IGroupOption extends IPersonaProps {
    group?: Group;
    groupType?: GroupType;
}

interface GroupSelectorProps {
    tenantId: string;
    className?: string;
    label: string;
    selectedOptions: IGroupOption[];
    onSelectionChanged: (groups: IGroupOption[]) => void;
    disabled: boolean;
    multiSelect: boolean;

    sectionFilter?: boolean; // add sds section filter to queries
    sdsSchoolId?: string; // add sds school id filter to queries

    graphClient: MicrosoftGraph.Client;
    apiService: ApiService;
    userIsCdbEmployee: boolean;
}

interface GroupSelectorState {
}

class GroupSelector extends Component<GroupSelectorProps, GroupSelectorState>
{
    static displayName = GroupSelector.name;

    public static groupToGroupOption(group: Group): IGroupOption {
        let groupType: GroupType = "Mail Enabled Security";
        if (group.groupTypes !== undefined && group.groupTypes.indexOf("Unified") !== -1) {
            groupType = "Office 365";
        }
        else if (group.mailEnabled === false && group.securityEnabled === true) {
            groupType = "Security";
        }
        else if (group.mailEnabled === true && group.securityEnabled === false) {
            groupType = "Distribution List"
        }

        return {
            id: group.id as string,
            text: group.displayName as string,
            secondaryText: `${groupType} Group ${group.mailNickname || group.id}`,
            group,
            groupType: groupType
        };
    }

    public static createSiteFormGroupToGroupOption(createSiteFormGroup: CreateSiteFormGroup): IGroupOption {
        return {
            id: createSiteFormGroup.groupId,
            text: createSiteFormGroup.groupDisplayName
        };
    }

    constructor(props: GroupSelectorProps) {
        super(props);


        this.state = {
        }

    }

    async componentDidMount(): Promise<void> {
    }

    private fetchGroupOptions = async (searchTerm: string): Promise<IGroupOption[]> => {

        let groups: Group[] = [];

        let filterParam: string | undefined;
        if (searchTerm) {
            filterParam = `startsWith(displayName,'${searchTerm}') OR startsWith(mailNickname,'${searchTerm}')`;

            if (this.props.sectionFilter === true) {
                filterParam = `(${filterParam}) AND extension_fe2174665583431c953114ff7268b7b3_Education_ObjectType eq 'Section'`;
            }
            if (this.props.sdsSchoolId) {
                filterParam = `(${filterParam}) AND extension_fe2174665583431c953114ff7268b7b3_Education_SyncSource_SchoolId eq '${this.props.sdsSchoolId}'`;
            }
        }

        if (this.props.userIsCdbEmployee) {
            groups = await this.props.apiService.searchGraphGroupsAdmin(this.props.tenantId, filterParam || "");
        }
        else {
            let reqBuilder = this.props.graphClient.api("/groups")
                .select(["id", "displayName", "groupTypes", "mailEnabled", 'securityEnabled', 'createdDateTime'])
                .top(300);

            if (filterParam) {
                reqBuilder = reqBuilder.filter(filterParam);
            }

            const response = await reqBuilder.get();

            groups = response.value;
        }

        let groupOptions: IGroupOption[] = groups
            .sort((a, b) => (getDateOnlyFromDateTimeString(b.createdDateTime).unix() - getDateOnlyFromDateTimeString(a.createdDateTime).unix()) ||
                a.displayName != undefined && b.displayName != undefined && a.displayName.localeCompare(b.displayName) || -1)
            .map((group: Group) => GroupSelector.groupToGroupOption(group));

        let filteredGroups = groupOptions.filter(groupOptions => groupOptions.groupType !== "Distribution List");

        return filteredGroups;
    }

    render(): JSX.Element {
        const onRenderSuggestionsItem = (personaProps: any, suggestionsProps: any) => (
                <PeoplePickerItemSuggestion
                    personaProps={personaProps}
                    suggestionsProps={suggestionsProps}
                    styles={{ personaWrapper: { width: '100%' } }
                    } />
        );
        return (
            <div className={this.props.className}>
                <Label>{this.props.label}</Label>
                <NormalPeoplePicker
                    disabled={this.props.disabled}
                    onResolveSuggestions={this.fetchGroupOptions}
                    selectedItems={this.props.selectedOptions}
                    onChange={(selectedPersonaProps?: IPersonaProps[]) => {
                        if (selectedPersonaProps !== undefined) {
                            const selectedGroup: IGroupOption[] = this.props.multiSelect ? selectedPersonaProps : selectedPersonaProps!.slice(0, 1) as IGroupOption[];
                            this.props.onSelectionChanged(selectedGroup);
                        } else {
                            this.props.onSelectionChanged([]);
                        }
                    }}
                    className={'ms-PeoplePicker'}
                    key={'normal'}
                    onRenderSuggestionsItem={onRenderSuggestionsItem}
                    resolveDelay={300}
                />
                <div className={"text-extra-detail"}>Search groups by display name or mail nickname</div>
            </div>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: {
        tenantId: string, sdsSchoolId?: string, className: string, label: string, selectedOptions: IGroupOption[], onSelectionChanged(groups: IGroupOption[]): void, disabled: boolean, multiSelect: boolean, sectionFilter?: boolean
    }): GroupSelectorProps => {
        return {
            tenantId: ownProps.tenantId,
            sdsSchoolId: ownProps.sdsSchoolId,

            className: ownProps.className,
            label: ownProps.label,
            selectedOptions: ownProps.selectedOptions,
            onSelectionChanged: ownProps.onSelectionChanged,
            disabled: ownProps.disabled,
            multiSelect: ownProps.multiSelect,
            sectionFilter: ownProps.sectionFilter,

            graphClient: state.auth.graphClient,
            apiService: state.auth.apiService,
            userIsCdbEmployee: state.auth.userIsCdbEmployee,
        };
    }
)(GroupSelector)